module.exports = __webpack_public_path__ + "static/media/155-israel.4da934cd.svg";